const AdmittedStatus = {
    "-1": 'not_admitted',
    "0": 'new',
    "1": 'admitted'
};

export default AdmittedStatus;

export function admittedFilters() {
    return  Object.fromEntries(
       Object.entries(AdmittedStatus)
    );
}

export function getText(statusID) {
    if (statusID === false){
        return AdmittedStatus["-1"]
    } else if (statusID === true){
        return AdmittedStatus["1"]
    }
}